import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    formId: Yup.number().nullable().required("Please select a form"),
    frequency: Yup.string().required("Please select a frequency"),
    isShareable: Yup.bool()
});